import { render, staticRenderFns } from "./ReportsSkroutz.vue?vue&type=template&id=50b364a6"
import script from "./ReportsSkroutz.vue?vue&type=script&lang=js"
export * from "./ReportsSkroutz.vue?vue&type=script&lang=js"
import style0 from "./ReportsSkroutz.vue?vue&type=style&index=0&id=50b364a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports